import { Input, Pipe, PipeTransform } from '@angular/core';
import { PessoasContactosRelacoes } from '../models/clientes/pessoas-contactos-relacoes';

@Pipe({
  name: 'codPerson',
  pure: true
}) export class PorPersonalidadePipe implements PipeTransform {

  transform(valores: PessoasContactosRelacoes[], codigo: string): any {
    if (valores.length > 0 && codigo) {
      return valores.filter(valor => valor.codPersonJuridica === codigo);
    }
    return [];
  }
}
